import { State } from 'src/types'
import { normalWristBelt } from './normalWristBelt'

export const wristBeltDrawer = async (ctx: CanvasRenderingContext2D, state: State, printLeatherTypeValue?: string): Promise<void> => {
  const isThumbIntegrated = state.baseModel.productNumber === 'APL-UR003+' || state?.beltType?.value === 'thumbIntegrated'
  if (!isThumbIntegrated) {
    await normalWristBelt(ctx, state.listBelt.color, state.stitch.color, printLeatherTypeValue)
  }
}
